<template>
  <!-- <div class="account-settings">
    <div class="account-settings-header">
      <div class="account-settings-header-title">
        <span>{{ "Settings" }}</span>
      </div>
      <div class="account-settings-header-description">
        <span>{{ "Manage your personal and organization settings." }}</span>
      </div>
    </div>
    <div class="h-svh">
      <div class="account-settings-body">
        <DeleteAccountModal v-if="deleteAccountModalShown" @close="deleteAccountModalShown = false" />
        <div class="account-profile-block">
          <div class="account-profile-text-container">
            <span class="title-profile">
              {{ "Profile" }}
            </span>
            <span class="description-profile">
              {{ "Manage details of your personal profile." }}
            </span>
          </div>

          <div class="account-profile-input-container">
            <div class="input-container">
              <div class="field-label">Name</div>
              <input ref="nameProjectInput" placeholder="User Name" type="text" class="input-field"
                v-model="userName" />
            </div>
            <div class="input-container">
              <div class="field-label">Email</div>
              <input ref="nameProjectInput" placeholder="User Email" type="text" class="input-field-not-editable"
                v-model="userEmail" readonly />
            </div>
          </div>
          <div class="account-profile-button-container">
            <ActionButton class="cancel-btn" text="Cancel" @click="cancelChanges" />
            <ActionButton class="rename-profile-btn" text="Save" @click="changeUserName" />
          </div>
        </div>
        <div class="account-delete-block">
          <div class="account-delete-text-container">
            <span class="delete-profile">
              {{ "Delete Account" }}
            </span>
            <span class="description-delete">
              {{ "Close and delete your account" }}
            </span>
          </div>
          <div class="action-button-container">
            <ActionButton class="delete-user-btn" text="Delete Account" :disabled="deleteButtonIsDisabled"
              @click="deleteAccountModalShown = true" />
          </div>
        </div>
        <div>
          <button @click="clearIndexDb()" type="button"
            class="rounded-full bg-white px-3.5 py-2 text-sm font-semibold
             text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50">
            Clear app cache
            </button>
        </div>
      </div>
    </div>
  </div> -->

  <div class="w-full min-h-svh">
    <div class="flex flex-col items-center justify-center h-24 bg-white border-b border-gray-200 border-b-gray-300">
      <h1 class="text-lg text-gary-700 font-semibold">Account Settings</h1>
      <p class="text-gray-500 text-sm font-normal">Manage your personal and organizational settings.</p>
    </div>
    <div class="w-full flex flex-col md:flex-row">
      <div class="p-8 min-w-56 text-sm font-semibold bg-white min-h-svh hidden md:block">
        <ul>
          <li
            :class="['flex rounded-lg flex-row items-center gap-2 p-2 cursor-pointer', activeView === 'Profile' ? 'bg-blue-50 text-blue-500' : 'hover:bg-blue-50 hover:text-blue-500']"
            @click="activeView = 'Profile'">
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
          d="M10 13C13.3137 13 16 10.3137 16 7C16 3.68629 13.3137 1 10 1C6.68629 1 4 3.68629 4 7C4 10.3137 6.68629 13 10 13Z"
          stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M1 18.25C2.81594 15.1122 6.11406 13 10 13C13.8859 13 17.1841 15.1122 19 18.25" stroke="black"
          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Profile
          </li>
          <!-- <li
            :class="['flex rounded-lg flex-row items-center gap-2 p-2 cursor-pointer', activeView === 'Notifications' ? 'bg-blue-50 text-blue-500' : 'hover:bg-blue-50 hover:text-blue-500']"
            @click="activeView = 'Notifications'">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
          d="M6 16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19C9.79565 19 10.5587 18.6839 11.1213 18.1213C11.6839 17.5587 12 16.7956 12 16"
          stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
          d="M2.24988 7.75C2.24988 5.95979 2.96104 4.2429 4.22691 2.97703C5.49278 1.71116 7.20967 1 8.99988 1C10.7901 1 12.507 1.71116 13.7729 2.97703C15.0387 4.2429 15.7499 5.95979 15.7499 7.75C15.7499 11.1081 16.528 13.8063 17.1468 14.875C17.2125 14.9888 17.2471 15.1179 17.2472 15.2493C17.2474 15.3808 17.2129 15.5099 17.1474 15.6239C17.0819 15.7378 16.9876 15.8325 16.874 15.8985C16.7603 15.9645 16.6313 15.9995 16.4999 16H1.49988C1.36861 15.9992 1.23985 15.964 1.12646 15.8978C1.01308 15.8317 0.919039 15.7369 0.853747 15.6231C0.788454 15.5092 0.754196 15.3801 0.754395 15.2489C0.754595 15.1176 0.789245 14.9887 0.854883 14.875C1.4727 13.8063 2.24988 11.1072 2.24988 7.75Z"
          stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Notifications
          </li>
          <li
            :class="['flex rounded-lg flex-row items-center gap-2 p-2 cursor-pointer', activeView === 'Security' ? 'bg-blue-50 text-blue-500' : 'hover:bg-blue-50 hover:text-blue-500']"
            @click="activeView = 'Security'">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
          d="M17.25 7.5V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5H1.5C1.30109 1.5 1.11032 1.57902 0.96967 1.71967C0.829018 1.86032 0.75 2.05109 0.75 2.25V7.5C0.75 16.5 9 18.75 9 18.75C9 18.75 17.25 16.5 17.25 7.5Z"
          stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.25 9.75L7.5 12L12.75 6.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
            </svg>
            Security
          </li>
          <li
            :class="['flex rounded-lg flex-row items-center gap-2 p-2 cursor-pointer', activeView === 'Integrations' ? 'bg-blue-50 text-blue-500' : 'hover:bg-blue-50 hover:text-blue-500']"
            @click="activeView = 'Integrations'">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 12.5L10.25 14.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path d="M12.5 12.5L10.25 14.75" stroke="#334155" stroke-width="1.5" />
              <path d="M9.5 9.5L7.25 11.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path d="M9.5 9.5L7.25 11.75" stroke="#334155" stroke-width="1.5" />
              <path d="M5 9.5L12.5 17" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path d="M4.44313 17.5569L1.25 20.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path
          d="M11.3751 15.875L8.65633 18.5938C8.23438 19.0157 7.66211 19.2527 7.06539 19.2527C6.46868 19.2527 5.89641 19.0157 5.47446 18.5938L3.40633 16.5228C2.98527 16.101 2.74878 15.5293 2.74878 14.9333C2.74878 14.3373 2.98527 13.7656 3.40633 13.3438L6.12508 10.625"
          stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.5 5L17 12.5" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path d="M17.5569 4.44313L20.75 1.25" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path
          d="M15.875 11.375L18.5938 8.65621C19.0157 8.23426 19.2527 7.66198 19.2527 7.06527C19.2527 6.46856 19.0157 5.89629 18.5938 5.47433L16.5228 3.40621C16.101 2.98514 15.5293 2.74866 14.9333 2.74866C14.3373 2.74866 13.7656 2.98514 13.3438 3.40621L10.625 6.12496"
          stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Integrations
          </li>
          <li
            :class="['flex rounded-lg flex-row items-center gap-2 p-2 cursor-pointer', activeView === 'Plans and Billing' ? 'bg-blue-50 text-blue-500' : 'hover:bg-blue-50 hover:text-blue-500']" @click="activeView = 'Plans and Billing'">
            <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
          d="M20 1.25H2C1.58579 1.25 1.25 1.58579 1.25 2V14C1.25 14.4142 1.58579 14.75 2 14.75H20C20.4142 14.75 20.75 14.4142 20.75 14V2C20.75 1.58579 20.4142 1.25 20 1.25Z"
          stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14.75 11.75H17.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path d="M10.25 11.75H11.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
              <path d="M1.25 5H20.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
            </svg>
            Plans and Billing
          </li> -->
        </ul>
      </div>
      <div>
        <ul class="block md:hidden p-4 bg-white min-h-svh">
          <li
            class="flex hover:text-blue-500 rounded-lg flex-row items-center gap-2 p-2 hover:bg-blue-50 cursor-pointer"
            @click="openPopup('Profile')">
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 13C13.3137 13 16 10.3137 16 7C16 3.68629 13.3137 1 10 1C6.68629 1 4 3.68629 4 7C4 10.3137 6.68629 13 10 13Z"
                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M1 18.25C2.81594 15.1122 6.11406 13 10 13C13.8859 13 17.1841 15.1122 19 18.25" stroke="black"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Profile
          </li>
          <!-- <li
            class="flex hover:text-blue-500 rounded-lg flex-row items-center gap-2 p-2 hover:bg-blue-50 cursor-pointer"
            @click="openPopup('Notifications')">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6 16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19C9.79565 19 10.5587 18.6839 11.1213 18.1213C11.6839 17.5587 12 16.7956 12 16"
                stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M2.24988 7.75C2.24988 5.95979 2.96104 4.2429 4.22691 2.97703C5.49278 1.71116 7.20967 1 8.99988 1C10.7901 1 12.507 1.71116 13.7729 2.97703C15.0387 4.2429 15.7499 5.95979 15.7499 7.75C15.7499 11.1081 16.528 13.8063 17.1468 14.875C17.2125 14.9888 17.2471 15.1179 17.2472 15.2493C17.2474 15.3808 17.2129 15.5099 17.1474 15.6239C17.0819 15.7378 16.9876 15.8325 16.874 15.8985C16.7603 15.9645 16.6313 15.9995 16.4999 16H1.49988C1.36861 15.9992 1.23985 15.964 1.12646 15.8978C1.01308 15.8317 0.919039 15.7369 0.853747 15.6231C0.788454 15.5092 0.754196 15.3801 0.754395 15.2489C0.754595 15.1176 0.789245 14.9887 0.854883 14.875C1.4727 13.8063 2.24988 11.1072 2.24988 7.75Z"
                stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Notifications
          </li>
          <li
            class="flex hover:text-blue-500 rounded-lg flex-row items-center gap-2 p-2 hover:bg-blue-50 cursor-pointer"
            @click="openPopup('Security')">
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.25 7.5V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5H1.5C1.30109 1.5 1.11032 1.57902 0.96967 1.71967C0.829018 1.86032 0.75 2.05109 0.75 2.25V7.5C0.75 16.5 9 18.75 9 18.75C9 18.75 17.25 16.5 17.25 7.5Z"
                stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.25 9.75L7.5 12L12.75 6.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Security
          </li>
          <li
            class="flex hover:text-blue-500 rounded-lg flex-row items-center gap-2 p-2 hover:bg-blue-50 cursor-pointer"
            @click="openPopup('Integrations')">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 12.5L10.25 14.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12.5 12.5L10.25 14.75" stroke="#334155" stroke-width="1.5" />
              <path d="M9.5 9.5L7.25 11.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M9.5 9.5L7.25 11.75" stroke="#334155" stroke-width="1.5" />
              <path d="M5 9.5L12.5 17" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M4.44313 17.5569L1.25 20.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M11.3751 15.875L8.65633 18.5938C8.23438 19.0157 7.66211 19.2527 7.06539 19.2527C6.46868 19.2527 5.89641 19.0157 5.47446 18.5938L3.40633 16.5228C2.98527 16.101 2.74878 15.5293 2.74878 14.9333C2.74878 14.3373 2.98527 13.7656 3.40633 13.3438L6.12508 10.625"
                stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.5 5L17 12.5" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M17.5569 4.44313L20.75 1.25" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M15.875 11.375L18.5938 8.65621C19.0157 8.23426 19.2527 7.66198 19.2527 7.06527C19.2527 6.46856 19.0157 5.89629 18.5938 5.47433L16.5228 3.40621C16.101 2.98514 15.5293 2.74866 14.9333 2.74866C14.3373 2.74866 13.7656 2.98514 13.3438 3.40621L10.625 6.12496"
                stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Integrations
          </li>
          <li
            class="flex hover:text-blue-500 rounded-lg flex-row items-center gap-2 p-2 hover:bg-blue-50 cursor-pointer"
            @click="openPopup('Plans and Billing')">
            <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 1.25H2C1.58579 1.25 1.25 1.58579 1.25 2V14C1.25 14.4142 1.58579 14.75 2 14.75H20C20.4142 14.75 20.75 14.4142 20.75 14V2C20.75 1.58579 20.4142 1.25 20 1.25Z"
                stroke="#334155" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14.75 11.75H17.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M10.25 11.75H11.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M1.25 5H20.75" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            Plans and Billing
          </li> -->
        </ul>

        <div v-if="activePopup" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div class="bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-md">
            <div>
              <div class="fixed  inset-0 bg-white z-50 overflow-auto">
                <div class="flex justify-center items-center p-4 border-b border-gray-200">
                  <button class="text-gray-500 absolute m-2 p-4 left-0 hover:text-gray-700" @click="activePopup = null">
                    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10.5 1L1.5 10L10.5 19" stroke="#334155" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>

                  </button>
                  <h2 class="text-lg font-semibold">{{ activePopup.label }}</h2>
                </div>
                <div class="">
                  <ProfileSettings v-if="activePopup.label=='Profile'"/>
                </div>
              </div>
            </div>
            <!-- <button class="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md" @click="closePopup">Close</button> -->
          </div>
        </div>
      </div>
      <div class="invisible flex-1 p-4 pl-10 md:visible stroke-gray-200">
        <ProfileSettings v-if="activeView=='Profile'"/>

      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "./ActionButton.vue";
import { inject, onMounted, ref, watch, computed } from "vue";
import DeleteAccountModal from "../app-bar/DeleteAccountModal.vue";
import ProfileService from "../../service/profileService";
import { BROADCAST_MESSAGE, ERROR_TOAST, SUCCESS_TOAST } from "../../core/constants.js";
import { useRouter } from "vue-router";
import ProfileSettings from "./components/accountSettings/ProfileSettings.vue";

export default {
  name: "AccountSettings",
  components: {
    DeleteAccountModal,
    ActionButton,
    ProfileSettings
  },
  setup() {
    const router = useRouter();
    const $auth0 = inject('$auth0');
    const $fetch = inject('$fetch');
    const deleteAccountModalShown = ref(false);
    const currentUserName = ref('')
    const userName = ref('');
    const userEmail = ref('');
    const busy = ref(false);
    const deleteButtonIsDisabled = ref(false);

    const hasActiveChanges = computed(() => {
      return userName.value !== currentUserName.value;
    });

    const saveButtonIsDisabled = computed(() => {
      return busy.value || !hasActiveChanges.value;
    });
    const profileService = new ProfileService();
    const activePopup = ref(null);
    const activeView = ref('Profile');
    onMounted(async () => {
      activeView.value = 'Profile';
      await fetchOwner()
    });

    async function fetchOwner() {
      try {
        busy.value = true;
        const { name = null, email = '', profilePicture = '' } = await profileService.getMyProfile();
        currentUserName.value = name
        userName.value = name;
        userEmail.value = email;
      } catch (e) {
        console.warn(e.message);
      } finally {
        busy.value = false;
      }
    }

    async function changeUserName() {
      if (!userName.value || !hasActiveChanges) return
      try {
        busy.value = true;
        await profileService.updateUserProfile({ email: userEmail.value, name: userName.value });
        $fetch.dispatch(BROADCAST_MESSAGE.TOAST, {
          type: SUCCESS_TOAST,
          message: "user name updated successfully"
        });
        await fetchOwner();
      } catch (e) {
        $fetch.dispatch(BROADCAST_MESSAGE.TOAST, {
          type: ERROR_TOAST,
          message: e.message
        });
      } finally {
        busy.value = false;
      }
    }

    async function cancelChanges() {
      if (!hasActiveChanges) return
      await router.push({ name: 'home' });
    }

    async function deleteAccount() {
      try {
        deleteButtonIsDisabled.value = true;
        await $fetch.deleteAccount()
        await $auth0.signOut();
      } catch (e) {
        $fetch.dispatch(BROADCAST_MESSAGE.TOAST, {
          type: ERROR_TOAST,
          message: e.message
        });
      } finally {
        deleteButtonIsDisabled.value = false;
      }
    }
    function clearIndexDb() {
      indexedDB.deleteDatabase('FOLIA_CACHE');
      router.push({ name: 'home' }).then(() => {
        location.reload();
      });
    }
    const openPopup = (v) => {
      console.log({v});
      
      activePopup.value = {
        label: v
      }
    }
    return {
      saveButtonIsDisabled, deleteButtonIsDisabled,
      userName, hasActiveChanges, deleteAccountModalShown, userEmail,

      deleteAccount, cancelChanges, changeUserName, clearIndexDb,
      activePopup, openPopup,activeView
    }
  }
};
</script>

<style scoped lang="scss">
.account-settings {
  display: flex;
  flex-direction: column;
  width: 100%;

  .account-settings-header {
    background-color: white;
    border-bottom: 1px solid #E2E8F0;
    display: flex;
    align-self: center;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 92px;

    .account-settings-header-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 32px;
      text-align: center;
      color: #334155;
    }

    .account-settings-header-description {
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #64748B
    }
  }

  .account-settings-body {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding-top: 24px;
    flex-direction: column;

    .account-profile-block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 24px;
      width: 688px;
      height: 228px;
      gap: 16px;
      background: #FFFFFF;
      border: 1px solid #E2E8F0;
      border-radius: 6px;

      .account-profile-text-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: start;

        .title-profile {
          font-weight: 500;
          font-size: 20px;
          line-height: 32px;
          color: #334155;
        }

        .description-profile {
          font-weight: 300;
          font-size: 14px;
          line-height: 20px;
          color: #64748B;
        }
      }

      .account-profile-input-container {
        display: flex;
        align-items: flex-start;
        text-align: start;
        flex-direction: row;
        gap: 16px;

        .input-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .field-label {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: #64748B;
          }

          .input-field {
            font-weight: 300;
            font-size: 14px;
            line-height: 20px;
            color: #334155;
            background: #F1F5F9;
            width: 312px;
            height: 36px;
            margin-top: 8px;
            box-sizing: border-box;
            padding: 0 8px;
            border: 0;
            border-radius: 6px;

            &:focus {
              outline: none;
              border: 2px solid #2990FF;
            }
          }

          .input-field-not-editable {
            font-weight: 300;
            font-size: 14px;
            line-height: 20px;
            color: #64748B;
            background: #E2E8F0;
            width: 312px;
            height: 36px;
            margin-top: 8px;
            box-sizing: border-box;
            padding: 0 8px;
            border: 0;
            border-radius: 6px;

            &:focus {
              outline: none;
            }
          }
        }
      }

      .account-profile-button-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;

        .cancel-btn {
          border: 1px solid #E2E8F0;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          width: 80px;
          height: 36px;
          border-radius: 8px;
          margin: 0;
        }

        .rename-profile-btn {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          border-radius: 8px;
          width: 65px;
          height: 36px;
          color: #FFFFFF;
          background-color: #334155;
          margin: 0;
        }
      }
    }

    .account-delete-block {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 24px;
      gap: 16px;
      width: 688px;
      height: 152px;
      background: #FFFFFF;
      border: 1px solid #E2E8F0;
      border-radius: 6px;

      .account-delete-text-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: start;

        .delete-profile {
          font-weight: 500;
          font-size: 20px;
          line-height: 32px;
          color: #334155;
        }

        .description-delete {
          font-weight: 300;
          font-size: 14px;
          line-height: 20px;
          color: #64748B;
        }
      }

      .action-button-container {
        width: 100%;
        display: flex;
        margin-left: -10px;
        flex-direction: row;
        align-items: flex-start;

        .delete-user-btn {
          border-radius: 8px;
          width: 137px;
          height: 36px;
          color: #FFFFFF;
          background-color: #F43F5E;
        }
      }
    }
  }
}
</style>
